<template>
  <ubi-page-container wide-main-content>
    <template v-slot:page-actions>
      <router-link :to="{ name: 'social-posts' }"><el-button type="warning" style="margin-right: 10px;">{{$t('socialPosts.models.backToPosts')}}</el-button></router-link>
      <router-link :to="{ name: 'post-editorial-modeles-create' }"><el-button type="primary">{{$t('socialPosts.models.createModel')}}</el-button></router-link>
    </template>
    <ubi-panel>
      <div v-html="$t('socialPosts.models.header')"></div>
    </ubi-panel>

    <el-dialog
        :visible.sync="modalDelete"
        :title="$t('socialPosts.models.deleteModelTitle')">
      {{$t('socialPosts.models.deleteModelConfirm')}}
      <el-button slot="footer" @click="SET_MODAL_DELETE(false)">{{$t('socialPosts.models.cancel')}}</el-button>
      <el-button slot="footer" type="danger" @click="deleteModelCall">{{$t('socialPosts.models.delete')}}</el-button>
    </el-dialog>

    <div v-if="isFromReseau">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('socialPosts.models.myModels')" name="perso">
          <models-table
            :list="list"
            :total="total"
            :page.sync="page"
            :limit.sync="limit"
            :loading-status="loadingStatus"
            :show-edit-delete="true"
            :limits="limits"
            @edit="edit"
            @use="useModel"
            @delete="openModalDelete"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('socialPosts.models.networkModels')" name="reseau">
          <models-table
            :list="listReseau"
            :total="totalReseau"
            :page.sync="pageReseau"
            :limit.sync="limitReseau"
            :loading-status="loadingStatus"
            :show-edit-delete="false"
            :limits="limits"
            @use="useModel"
          />
        </el-tab-pane>
      </el-tabs>
    </div>

    <models-table
      v-else
      :list="list"
      :total="total"
      :page.sync="page"
      :limit.sync="limit"
      :loading-status="loadingStatus"
      :show-edit-delete="true"
      :limits="limits"
      @edit="edit"
      @use="useModel"
      @delete="openModalDelete"
    />
  </ubi-page-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import UbiPanel from '@/components/Panel.vue'
import SocialPostsListHeader from '@/pages/socialNetworks/Blocks/SocialPostsListHeader.vue'
import { Tabs, TabPane } from 'element-ui'
import ModelsTable from './components/ModelsTable.vue'
import UbiPageContainer from '@/components/PageContainer.vue'

export default {
  name: 'SelectFromModele',
  components: {
    UbiPageContainer,
    SocialPostsListHeader,
    UbiPanel,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ModelsTable
  },
  data () {
    return {
      limits: [5, 10, 20],
      isFromReseau: false,
      activeTab: 'perso',
      modelsLoaded: false,
      modelsReseauLoaded: false
    }
  },
  computed: {
    ...mapGetters('socialPostsEditoModeles', [
      'list',
      'listReseau',
      'total',
      'totalReseau',
      'modalDelete',
      'modelIdToDelete'
    ]),
    ...mapState('socialPostsEditoModeles', [
      'loadingStatus'
    ]),
    page: {
      get () {
        return this.$store.state.socialPostsEditoModeles.filter.page
      },
      set (value) {
        this.setPage(value)
        this.loadModels()
        this.modelsLoaded = true
      }
    },
    limit: {
      get () {
        return this.$store.state.socialPostsEditoModeles.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.loadModels()
        this.modelsLoaded = true
      }
    },
    pageReseau: {
      get () {
        return this.$store.state.socialPostsEditoModeles.filterReseau.page
      },
      set (value) {
        this.setPageReseau(value)
        this.loadModelsReseau()
        this.modelsReseauLoaded = true
      }
    },
    limitReseau: {
      get () {
        return this.$store.state.socialPostsEditoModeles.filterReseau.limit
      },
      set (value) {
        this.setLimitReseau(value)
        this.loadModelsReseau()
        this.modelsReseauLoaded = true
      }
    }
  },
  methods: {
    ...mapMutations('socialPostsEditoModeles', [
      'setPage',
      'setLimit',
      'setTotal',
      'setPageReseau',
      'setLimitReseau',
      'SET_MODEL_ID_TO_DELETE',
      'SET_MODAL_DELETE'
    ]),
    ...mapActions('socialPostsEditoModeles', [
      'loadModels',
      'loadModelsReseau',
      'deleteModel'
    ]),
    edit (id) {
      this.$router.push({ name: 'post-editorial-modeles-edit', params: { id: id } })
    },
    useModel (model) {
      this.$router.push({ name: 'post-editorial-modeles-use', params: { id: model.id, reference: model.reference, login: model.advertiser.login } })
    },
    async deleteModelCall () {
      await this.deleteModel(this.modelIdToDelete)
      this.loadModels()
      this.modelsLoaded = true
    },
    openModalDelete (id) {
      this.SET_MODAL_DELETE(true)
      this.SET_MODEL_ID_TO_DELETE(id)
    },
    handleTabClick (tab) {
      if (tab.name === 'reseau' && !this.modelsReseauLoaded) {
        this.loadModelsReseau()
        this.modelsReseauLoaded = true
      } else if (tab.name === 'perso' && !this.modelsLoaded) {
        this.loadModels()
        this.modelsLoaded = true
      }
    },
    async checkReseauModels () {
      try {
        await this.loadModelsReseau()
        this.modelsReseauLoaded = true
        this.isFromReseau = this.totalReseau > 0
      } catch (error) {
        console.error('Erreur lors du chargement des modèles du réseau:', error)
        this.isFromReseau = false
        this.modelsReseauLoaded = false
      }
    }
  },
  async beforeMount () {
    await this.loadModels()
    this.modelsLoaded = true

    await this.checkReseauModels()
  }
}
</script>

<style scoped>
.ligne {
  background-color: #66BCC8 !important;
}
</style>
